export default {
    devices_bulk_pairing_title: "Bulk Pairing",
    devices_bulk_pairing_manual: "Manual",
    devices_bulk_pairing_copy_paste: "Copy Paste",
    devices_bulk_pairing_vidfleet_esn: "Camera ESN",
    devices_bulk_pairing_gps_esn: "GPS ESN",
    devices_bulk_pairing_add: "Add",
    devices_bulk_pairing_pair_devices: "Pair Devices",
    devices_bulk_pairing_label_copy: "Camera ESN (space) GPS ESN",
    devices_bulk_pairing_esn_already_added: "The camera ESN is already added",
    devices_bulk_pairing_gps_already_added: "The gps ESN is already added",
    devices_bulk_pairing_message: "Message",
    devices_bulk_pairing_camera_is_invalid: "The ESN of the camera is invalid",
    devices_bulk_pairing_gps_is_invalid: "The ESN of the gps is invalid",
    devices_bulk_pairing_paired: "Paired",
    devices_bulk_camera_not_linked_mode: "Camera is NOT in Paired mode",
    devices_bulk_camera_manufacturer_must_vidfleet_smartwitness: "The camera manufacturer must be Vidfleet, SmartWitness or LightMetrics",
    devices_bulk_camera_manufacturer_must_diferent_vidfleet_smartwitness: "The gps manufacturer must be different from Vidfleet, SmartWitness or LightMetrics",
    devices_bulk_same_as_that_of_gps: "The ESN of the camera cannot be the same as that of the gps",
    devices_bulk_is_neces_add_esn_gps: "It is necessary to add the ESN of the gps",
    devices_bulk_error_same_company: "The camera and gps must be from the same company",

    devices_bulk_cameras_must_be_vidfleet_or_smartWitness: "The manufacturer of the cameras must be VidFleet, SmartWitness or LightMetrics",
    devices_bulk_cameras_must_be_in_paired_mode: "The cameras must be in paired mode",
    devices_bulk_devices_must_be_from_the_same_company: "Devices must be from the same company",
    devices_bulk_esn_the_cameras_entered_must_be_valid: "The ESN of the cameras entered must be valid",
    devices_bulk_gps_must_be_different_from_vidfleet_or_smartWitness: "The manufacturer of the gps must be different from Vidfleet, SmartWitness or LightMetrics",
    devices_bulk_esn_of_cameras: "ESN of cameras",
    devices_bulk_number_gps_does_not_match_the_number_of_cameras_entered: "The number of gps does not match the number of cameras entered",
    devices_bulk_esn_of_gps: "ESN of gps",
    devices_bulk_rule_pairing: "It is necessary to enter the esn of the devices in order as they are to be paired",
    devices_bulk_there_are_invalid_esn: "There are invalid esn's",
    devices_bulk_confirm_change_type: "If you continue and change the type, the previously added cameras will be deleted",
    devices_bulk_gps_vs_cameras_message: "The ESN of the gps cannot be the same as the ESN of the cameras",
    devices_bulk_pairing_timezone_assign: "The timezone configured on the gps device will be asigned to the camera",
    devices_bulk_pairing_transaction_message: "The request to pair the devices and cameras has been sent successfully, please check the transactions list to see the status of the request.",
}
